"use strict";

var _defineProperty = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/defineProperty.js");

var _regeneratorRuntime = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _createClass = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _inherits = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClientActions = void 0;

var FetchActions_1 = require("../lib/FetchActions");

var ClientActions = /*#__PURE__*/function (_FetchActions_1$Fetch) {
  _inherits(ClientActions, _FetchActions_1$Fetch);

  var _super = _createSuper(ClientActions);

  function ClientActions() {
    var _this;

    _classCallCheck(this, ClientActions);

    _this = _super.apply(this, arguments);

    _this.post = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(body) {
        var path;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                path = _this.leadType === "debt" ? "/leads/debt" : "/leads";
                _context.next = 3;
                return _this.execute(path, body);

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.update = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(leadId, body) {
        var updateOptions,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                updateOptions = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
                _context2.next = 3;
                return _this.execute("/leads/update/".concat(leadId), body, {
                  queryParams: updateOptions
                });

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.review = function (leadId, status, reviewOptions) {
      return _this.execute("/leads/review/".concat(leadId), {}, {
        queryParams: _objectSpread({
          status: status
        }, reviewOptions)
      });
    };

    return _this;
  }

  return _createClass(ClientActions);
}(FetchActions_1.FetchActions);

exports.ClientActions = ClientActions;